import { MESSAGE_TYPE } from '@/constants/conversation/constants';

export default class EcsConversation {
  constructor(eventData) {
    if (eventData && eventData.interactionId && eventData.elementId) {
      Object.assign(this, this.createConversationFromEvent(eventData));
    }
  }

  get lastMessageTimestamp() {
    if (this.messages.length < 1) {
      return null;
    }
    return this.messages[this.messages.length - 1].timestamp;
  }

  get lastMessage() {
    return this.messages[this.messages.length - 1];
  }

  static purgeSystemMessages(messages) {
    return messages.filter(message => message.type !== MESSAGE_TYPE.system);
  }

  createConversationFromEvent({ interactionId, elementId, isTyping, messages }) {
    return {
      elementId,
      interactionId,
      isTyping: isTyping || [],
      messages: messages || []
    };
  }
}
